<script setup>
import { ref, watch } from 'vue';
import { defineProps, defineEmits } from 'vue';
import api from '@/services/apiService';

const props = defineProps({
  show: Boolean,
});

const emit = defineEmits(['close', 'saved']);

const categoryName = ref('');
const errorMessage = ref('');

watch(() => props.show, (val) => {
  if (val) {
    categoryName.value = '';
    errorMessage.value = '';
  }
});

const saveCategory = async () => {
  if (!categoryName.value) {
    errorMessage.value = 'Category name is required.';
    return;
  }

  try {
    await api.post('/blog_categories', {
      name: categoryName.value,
    });

    // Refetch the full category list and find the newly created one
    const categoriesResponse = await api.get('/blog_categories?pagination=false');
    const allCategories = categoriesResponse.data.member || [];

    // Find the one that matches by name
    const newCategory = allCategories.find(cat => cat.name === categoryName.value);

    if (newCategory) {
      emit('saved', newCategory); // Emit the new full object with id
    } else {
      errorMessage.value = 'Category saved but not found in list.';
      return;
    }

    emit('close');
  } catch (err) {
    errorMessage.value = err.response?.data?.message || 'Error saving category.';
  }
};

const close = () => {
  emit('close');
};
</script>


<template>
  <teleport to="body">
    <div v-if="show" class="modal-overlay" @click="close">
      <div class="modal-content" @click.stop>
        <h5 class="mb-3">Add New Category</h5>
        <div v-if="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
        </div>
        <div class="mb-3">
          <label class="form-label">Category Name</label>
          <input v-model="categoryName" type="text" class="form-control" />
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn btn-secondary me-2" @click="close">Cancel</button>
          <button class="btn btn-primary" @click="saveCategory">Save</button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 24px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
}
</style>
